function stripHtml(html) {
  if (!html) return '';
  return String(html)
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

/** Texte + visuels pour export réseaux (sans lien app HubUP). */
export function buildHubupNotificationSharePack(message, resolveAssetUrl) {
  const title = String(message?.title || '').trim();
  const body = stripHtml(message?.bodyHtml || message?.body || '');
  const rawImages = [];
  if (Array.isArray(message?.imageUrls)) {
    rawImages.push(...message.imageUrls);
  } else if (message?.imageUrl) {
    rawImages.push(message.imageUrl);
  }

  const imageUrls = [
    ...new Set(
      rawImages
        .map((p) => String(p || '').trim())
        .filter(Boolean)
        .map((p) => (typeof resolveAssetUrl === 'function' ? resolveAssetUrl(p) : p))
        .filter(Boolean),
    ),
  ];

  const parts = [title, body].filter(Boolean);
  const defaultText = parts.join('\n\n');

  return {
    title,
    body,
    imageUrls,
    defaultText,
  };
}

export function openTwitterShare(text) {
  const url = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
  window.open(url, '_blank', 'noopener,noreferrer,width=550,height=420');
}

/** LinkedIn ne préremplit pas toujours via URL : copie + ouverture du fil avec param texte. */
export async function openLinkedInShare(text) {
  const trimmed = String(text || '').trim();
  if (!trimmed) return { copied: false };

  let copied = false;
  try {
    await navigator.clipboard.writeText(trimmed);
    copied = true;
  } catch {
    /* ignore */
  }

  const url = `https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(trimmed.slice(0, 2800))}`;
  window.open(url, '_blank', 'noopener,noreferrer,width=640,height=820');
  return { copied };
}

/** Partage Facebook : texte dans quote (pas de lien HubUP / externe). */
export async function openFacebookShare(text) {
  const trimmed = String(text || '').trim();
  if (!trimmed) return { copied: false };

  let copied = false;
  try {
    await navigator.clipboard.writeText(trimmed);
    copied = true;
  } catch {
    /* ignore */
  }

  const url = `https://www.facebook.com/sharer/sharer.php?quote=${encodeURIComponent(trimmed.slice(0, 5000))}`;
  window.open(url, '_blank', 'noopener,noreferrer,width=640,height=720');
  return { copied };
}

export function openWhatsAppShare(text) {
  const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}

export async function copyShareText(text) {
  await navigator.clipboard.writeText(text);
}

export async function downloadShareImage(imageUrl, filenameBase = 'hubup-visuel') {
  const res = await fetch(imageUrl, { mode: 'cors' });
  if (!res.ok) throw new Error('fetch failed');
  const blob = await res.blob();
  const ext =
    blob.type === 'image/png'
      ? 'png'
      : blob.type === 'image/webp'
        ? 'webp'
        : blob.type === 'image/gif'
          ? 'gif'
          : 'jpg';
  const objectUrl = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = `${filenameBase}.${ext}`;
  a.rel = 'noopener';
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(objectUrl);
}

export async function tryNativeShare({ title, text, imageUrls = [] }) {
  if (!navigator.share) return { ok: false, reason: 'unsupported' };
  const files = [];
  for (let i = 0; i < Math.min(imageUrls.length, 4); i += 1) {
    try {
      const res = await fetch(imageUrls[i], { mode: 'cors' });
      if (!res.ok) continue;
      const blob = await res.blob();
      if (!blob.type.startsWith('image/')) continue;
      files.push(new File([blob], `hubup-${i + 1}.jpg`, { type: blob.type }));
    } catch {
      /* skip */
    }
  }
  const payload =
    files.length > 0 && navigator.canShare?.({ files })
      ? { title, text, files }
      : { title, text };
  await navigator.share(payload);
  return { ok: true };
}
